export class GridSearchFilter {
    label: string;
    field: string;
    type: string = 'text';
    getOptions: any = null;
}
